module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVEL-M7-77bd9e1dfbbec5064b6753e66484181c.jpg";